export type BillingTerm = "monthly" | "annual" | "twoYear" | "threeYear";

const billingTerms: {
  value: BillingTerm;
  label: string;
  months: number;
  billedMonths: number;
  saving: string;
}[] = [
  {
    value: "monthly",
    label: "Monthly",
    months: 1,
    billedMonths: 1,
    saving: "",
  },
  {
    value: "annual",
    label: "Annual",
    months: 12,
    billedMonths: 10,
    saving: "2 months free",
  },
  {
    value: "twoYear",
    label: "2 years",
    months: 24,
    billedMonths: 18,
    saving: "6 months free",
  },
  {
    value: "threeYear",
    label: "3 years",
    months: 36,
    billedMonths: 28,
    saving: "8 months free",
  },
];

function monthlyCents(price: string) {
  const amount = Number.parseFloat(price.replace(/[^\d.]/g, ""));
  return Math.round(amount * 100);
}

export function billingPrice(price: string, term: BillingTerm) {
  const selected = billingTerms.find((item) => item.value === term)!;
  const cents = monthlyCents(price) * selected.billedMonths;
  return `$${(cents / 100).toFixed(2)}`;
}

export function billingDescription(price: string, term: BillingTerm) {
  const selected = billingTerms.find((item) => item.value === term)!;
  if (term === "monthly") return `${price}/month`;

  const period =
    selected.months === 12 ? "year" : `${selected.months / 12} years`;
  return `${billingPrice(price, term)} billed every ${period}`;
}

export function BillingToggle({
  value,
  onChange,
}: {
  value: BillingTerm;
  onChange: (term: BillingTerm) => void;
}) {
  return (
    <div
      className="flex flex-wrap items-center gap-1 rounded-2xl border border-ink/10 bg-white p-1.5"
      aria-label="Billing term"
    >
      {billingTerms.map((term) => (
        <button
          key={term.value}
          type="button"
          onClick={() => onChange(term.value)}
          className={`rounded-xl px-3 py-2 text-xs font-bold transition ${value === term.value ? "bg-ink text-cream" : "text-ink/65 hover:bg-cream"}`}
        >
          {term.label}
        </button>
      ))}
    </div>
  );
}

export function BillingSaving({ term }: { term: BillingTerm }) {
  const selected = billingTerms.find((item) => item.value === term)!;
  if (!selected.saving) return null;

  return <p className="mt-2 text-xs font-bold text-moss">{selected.saving}</p>;
}
